import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    GetPeerConfiguration: [],
    loading: false,
    error: null,
}

const GetPeerConfigurationSlice = createSlice({
    name: "GetPeerConfiguration",
    initialState,
    reducers: {
        fetchGetPeerConfigurationStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchGetPeerConfigurationSuccess: (state, action) => {
            state.loading = false,
                state.GetPeerConfiguration = action.payload;
        },
        fetchGetPeerConfigurationFailure: (state, action) => {
            state.loading = false,
                state.error = action.payload;
        },
    },
})
export const {
    fetchGetPeerConfigurationStart,
    fetchGetPeerConfigurationSuccess,
    fetchGetPeerConfigurationFailure,
} = GetPeerConfigurationSlice.actions;

export default GetPeerConfigurationSlice.reducer;